<template>
  <button
    class="btn"
    :class="btnClass"
    v-on="$listeners">
    <img
      src="@/assets/images/icon_condition.svg"
      class="condition-button-img"
      :style="btnImgStyle">
    <span class="condition-button-text">コンディション</span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    btnClass() {
      const arrayClass = ['condition-button']
      if (this.xl) arrayClass.push('condition-button--xl')
      if (this.active) arrayClass.push('condition-button--active')
      return arrayClass
    },
    btnImgStyle() {
      if (this.xl) return {width: '50%'}
      return {width: '50%'}
    }
  },
}
</script>

<style scoped lang="scss">
.condition-button{
  position: relative;
  background-color: $white;
  box-shadow: 1px 2px 6px $grey05;
  border-radius: 50%;
  border: none;
  width: 60px;
  height: 60px;

  .condition-button-img {
    height: auto;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 15%;
    filter: invert(51%) sepia(51%) saturate(5133%) hue-rotate(176deg) brightness(90%) contrast(105%);
  }

  .condition-button-text {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 23%;
    font-size: 8px;
    font-feature-settings: "palt";
    color: $l-blue;
  }

  &--active{
    .condition-button-img {
      filter: invert(17%) sepia(39%) saturate(5752%) hue-rotate(207deg) brightness(70%) contrast(94%);
    }

    .condition-button-text {
      color: $blue;
    }
  }

  &:active {
    background-color: $blue;
  }
}

.condition-button--xl {
  width: 80px;
  height: 80px;
}
</style>